import { Component, Input } from '@angular/core';
import { FormMetricsLegendItem } from '../utils/form-metrics-legend.util';

/**
 * Standby — legenda HTML com Feather. Ativada quando USE_CUSTOM_CHART_LEGEND = true.
 * Preferência atual: legend nativa do Apex (ações/toggle).
 */
@Component({
  selector: 'app-form-metrics-chart-legend',
  templateUrl: './form-metrics-chart-legend.component.html',
  styleUrls: ['./form-metrics-chart-legend.component.scss'],
})
export class FormMetricsChartLegendComponent {
  @Input() items: FormMetricsLegendItem[] = [];
}
